export default __webpack_public_path__ + "static/media/books2-afterB-1440w.fd6d97a1.png";